import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { ReloadIcon } from '@beef/ui-kit';

import { formatPhone } from 'utils/formatting';
import { Heading } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class FancyNumbersLayout extends React.Component {
  state = { arrowActive: false };

  changeNumberHandler = () => {
    this.setState({ arrowActive: !this.state.arrowActive });
    this.props.changeNumber();
  };

  render() {
    const { activeNumber, categoryText, inlineStyle } = this.props;

    const { arrowActive } = this.state;

    return (
      <div className={cx('wrapper')}>
        <div className={cx('category', inlineStyle && 'inlineCategory')}>{categoryText}</div>
        <Heading level={4} className={cx('number', inlineStyle && 'inlineHeading')}>
          {formatPhone(activeNumber)}
        </Heading>
        <div className={cx(inlineStyle && 'inlineArrow')}>
          <span
            className={cx('action', arrowActive ? 'actionActive' : '')}
            onClick={this.changeNumberHandler}
            role="button"
            tabIndex="0"
          >
            <ReloadIcon size="l" fill="#767676" />
          </span>
        </div>
      </div>
    );
  }
}

FancyNumbersLayout.propTypes = {
  activeNumber: PropTypes.string,
  changeNumber: PropTypes.func,
  categoryText: PropTypes.string,
  inlineStyle: PropTypes.bool,
};

FancyNumbersLayout.defaultProps = {
  categoryText: 'Специальное предложение',
};
